import confetti from 'canvas-confetti';

// Фразы для подростков 7–11 класс. Стараемся без приторного «ты молодец,
// смайлик», но и не сухо — короткое, честное, с лёгкой ноткой уважения.
export const FINISH_PHRASES: readonly string[] = [
  'Сделано. Маленькое усилие сейчас — завтрашняя уверенность.',
  'Закрыто. Мозг как мышца — сегодня он стал чуть сильнее.',
  'Финиш. Большое всегда складывается из «просто сел и сделал».',
  'Есть. Математика уступает тем, кто не сдаётся.',
  'Готово. Ещё одна задача переведена из «страшно» в «решил».',
  'Точка. Ты уже знаешь чуть больше, чем десять минут назад.',
  'Сдано. Настоящее «само получается» копится именно в такие минуты.',
  'Финита. Дистанция немного короче — цель чуть ближе.',
  'Завершено. Эйнштейн тоже начинал с того, что просто садился и решал.',
  'Сделал(а). Уверенность растёт не от понимания, а от количества решённых задач.',
  'Готово. Этот навык никто уже не отнимет — он твой.',
  'Есть! То, что раньше казалось сложным, становится обычным.',
  'Задача закрыта. Один шаг — небольшой. Сотня шагов — уже путь.',
  'Финиш. Сделал домашку — сделал вклад в будущую десятку.',
  'Точка поставлена. А ты молодец — без пафоса, по делу.',
];

export function pickFinishPhrase(): string {
  const i = Math.floor(Math.random() * FINISH_PHRASES.length);
  return FINISH_PHRASES[i]!;
}

// Праздничный салют: несколько залпов из разных точек экрана.
export function fireCelebration(): void {
  const duration = 1200;
  const end = Date.now() + duration;

  const defaults: confetti.Options = {
    startVelocity: 30,
    spread: 70,
    ticks: 60,
    zIndex: 100,
  };

  function frame() {
    const timeLeft = end - Date.now();
    if (timeLeft <= 0) return;
    const particleCount = 40 * (timeLeft / duration);
    confetti({
      ...defaults,
      particleCount,
      origin: { x: Math.random() * 0.3 + 0.1, y: Math.random() * 0.3 + 0.2 },
    });
    confetti({
      ...defaults,
      particleCount,
      origin: { x: Math.random() * 0.3 + 0.6, y: Math.random() * 0.3 + 0.2 },
    });
    requestAnimationFrame(frame);
  }
  // Начальный большой «хлопок» по центру.
  confetti({
    particleCount: 120,
    spread: 90,
    origin: { x: 0.5, y: 0.35 },
    zIndex: 100,
  });
  frame();
}
